export default __webpack_public_path__ + "static/media/highwayBW.d7e3e5d8.jpg";